import check from '@/components/check/check'
import ticket from '@/components/check/ticket'
import today from '@/components/check/today'
let routes = [
    {
      path: '/check',
      name: 'check',
      component: check,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: ticket,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/today',
      name: 'today',
      component: today,
      meta: {
        requiresAuth: true
      }
    }
  ]
export default { routes }


// WEBPACK FOOTER //
// ./src/router/check.js